import React from 'react';
import { SvgIcon } from '@material-ui/core';

const NewsIcon = (props) => {
  return(
    <SvgIcon viewBox="0 0 250 250" {...props}>
      <g id="feeback" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group" transform="translate(-35.000000, -36.000000)" fillRule="nonzero">
          <circle id="Mask" fill="#2EBCAE" transform="translate(160.500000, 160.500000) rotate(-23.250000) translate(-160.500000, -160.500000) " cx="160.5" cy="160.5" r="122.035345"></circle>
          <path d="M233.3915,104.547795 L281.889877,173.221521 C277.398681,215.695332 250.704389,254.563483 208.670407,272.622707 C193.715732,279.047742 178.187018,282.251289 162.858977,282.542424 L96.101737,199.464175 C93.9534664,169.708284 100.752887,149.386893 116.5,138.5 C132.247113,127.613107 171.210946,116.295706 233.3915,104.547795 Z" id="Combined-Shape" fill="#199D8E"></path>
          <path d="M219.258464,96 L112.775393,96 C102.958315,96 95,104.007005 95,113.884147 L95,194.345777 C95,204.222918 102.958315,212.229924 112.775393,212.229924 L139.421555,212.229924 L139.421555,235.666673 C139.448346,236.921035 140.158286,238.059042 141.269377,238.628668 C142.380469,239.198293 143.712834,239.107317 144.737244,238.391876 L179.407725,212.195859 L219.258464,212.195859 C229.062318,212.17707 237,204.175565 237,194.311712 L237,113.884147 C237,104.020293 229.062318,96.0187883 219.258464,96 Z" id="Shape" fill="#FFFFFF"></path>
        </g>
        <rect id="Rectangle" fill="#199D8E" x="78" y="86" width="106" height="22" rx="8"></rect>
        <rect id="Rectangle" fill="#199D8E" x="78" y="124" width="53" height="22" rx="8"></rect>
      </g>
    </SvgIcon>
  );
};

export default NewsIcon;
